/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated with ApiClientGenerator, using the NSwag toolchain
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosRequestConfig, AxiosPromise, AxiosInstance, CancelToken } from 'axios';
import { injectable, inject, optional, symbolToken } from '@servicetitan/react-ioc';
// @ts-ignore: needed for Date serialization if a DateTime parameter has an Unspecified attribute on it
import moment from 'moment';

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_CurrentUserClientApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_CurrentUserClientApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class CurrentUserClientApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_CurrentUserClientApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_CurrentUserClientApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    getUserName(cancelToken?: CancelToken): AxiosPromise<UserDetails> {
        let url_ = "/standalone/api/userops/v1/CurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<UserDetails>(options_);
    }
}

interface ClientApiConfig {
    baseUrl: string;
    axios: AxiosInstance;
}

export const BASE_URL_TOKEN_PartitionsClientApi = symbolToken<string>('BASE_URL_TOKEN', false);
export const AXIOS_TOKEN_PartitionsClientApi = symbolToken<string>('AXIOS_TOKEN', false);

@injectable()
export class PartitionsClientApi {
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
    protected readonly opts: ClientApiConfig;

    constructor(
        @inject(BASE_URL_TOKEN_PartitionsClientApi) @optional() baseUrl = '',
        @inject(AXIOS_TOKEN_PartitionsClientApi) @optional() axiosInstance = axios,
    ) {

        this.opts = {
            baseUrl,
            axios: axiosInstance,
        };
    }

    switchPartitions(partitionInternalId: string, iru: string, cancelToken?: CancelToken): AxiosPromise<UserOpsServiceResponse> {
        let url_ = "/standalone/api/userops/v1/Partitions/switch?";
        if (partitionInternalId === undefined || partitionInternalId === null)
            throw new Error("The parameter 'partitionInternalId' must be defined and cannot be null.");
        else
            url_ += "partition_internal_id=" + encodeURIComponent("" + partitionInternalId) + "&";
        if (iru === undefined || iru === null)
            throw new Error("The parameter 'iru' must be defined and cannot be null.");
        else
            url_ += "initial_redirect_uri=" + encodeURIComponent("" + iru) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<UserOpsServiceResponse>(options_);
    }

    userAssignedPartitions(cancelToken?: CancelToken): AxiosPromise<(PartitionInfo | undefined)[]> {
        let url_ = "/standalone/api/userops/v1/Partitions/userassigned";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            baseURL: this.opts.baseUrl,
            cancelToken,
            url: url_,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.opts.axios.request<(PartitionInfo | undefined)[]>(options_);
    }
}

export class UserDetails implements IUserDetails {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IUserDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserDetails {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserDetails {
    id: string | undefined;
    name: string | undefined;
}

export class UserOpsServiceResponse implements IUserOpsServiceResponse {
    success!: boolean;
    redirectUri!: string | undefined;
    error!: string | undefined;
    errorDescription!: string | undefined;
    timestamp!: Date;

    constructor(data?: IUserOpsServiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.redirectUri = _data["redirectUri"];
            this.error = _data["error"];
            this.errorDescription = _data["errorDescription"];
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserOpsServiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserOpsServiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["redirectUri"] = this.redirectUri;
        data["error"] = this.error;
        data["errorDescription"] = this.errorDescription;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserOpsServiceResponse {
    success: boolean;
    redirectUri: string | undefined;
    error: string | undefined;
    errorDescription: string | undefined;
    timestamp: Date;
}

export class PartitionInfo implements IPartitionInfo {
    internal_id!: string;
    name!: string;
    display_name!: string;

    constructor(data?: IPartitionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internal_id = _data["internal_id"];
            this.name = _data["name"];
            this.display_name = _data["display_name"];
        }
    }

    static fromJS(data: any): PartitionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PartitionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internal_id"] = this.internal_id;
        data["name"] = this.name;
        data["display_name"] = this.display_name;
        return data;
    }
}

export interface IPartitionInfo {
    internal_id: string;
    name: string;
    display_name: string;
}
